<table id="results-table" class="custom-table">
    <thead>
        <tr>
            @for (column of columns; track column; let index = $index) {
                <th [class.centered]="column.centered" [style.min-width]="column.minWidth" [style.width]="column.width">
                    <span>{{ column.name | translate }}</span>
                </th>
            }
        </tr>
    </thead>

    @if (resultsList().length) {
        <tbody>
            @for (result of resultsList(); track result; let index = $index) {
                <ng-container
                    [ngTemplateOutlet]="tableRow"
                    [ngTemplateOutletContext]="{ result: result, rowIndex: index }">
                </ng-container>
            }
        </tbody>
    }
</table>

@if (!resultsList().length) {
    <div id="results-empty-states-container">
        <div id="results-empty-state">
            <app-table-empty-state
                [text1]="'dashboard.orderResults.emptyState.firstSentence' | translate"
                [text2]="'dashboard.orderResults.emptyState.secondSentence' | translate"
                [btnText]="'order.list.table.noOrdersEmptyState.createOrder' | translate"
                [btnLink]="orderSetupRoute()"
                [icon]="'fa-duotone fa-file-check'">
            </app-table-empty-state>
        </div>
    </div>
}

<ng-template #tableRow let-result="result" let-rowIndex="rowIndex">
    <tr
        app-results-table-row
        class="table-row"
        [class.odd]="rowIndex % 2 === 0"
        [class.even]="rowIndex % 2 === 1"
        [id]="result.id + '-row'"
        [columns]="columns"
        [result]="result"></tr>
</ng-template>
